export class HealthStat {
  value: number;
  cssClass?: string;
  cssClassSpan?: string;
  trend?: boolean; // true ==> increase; false ==> decrease in trend
}
